<template>
	<div class="wrap">
		<div class="container">
			<div class="login">
				<van-tabs v-model="activeName" type="card">
					<van-tab title="登录" name="a">
						<div class="adddz login_input">
							<form>
								<div class="address_require">
									<label>邮箱<span>*</span></label>
									<input type="email" v-model="email">
								</div>
								<div class="address_require">
									<label>密码<span>*</span></label>
									<input type="password" v-model="password">
								</div>
								<router-link class="wjmb" :to="{path:'/password'}">忘记密码?</router-link>
								<van-button type="primary"  block v-on:click="dologin()">登录</van-button>
							</form>
						</div>
					</van-tab>
					<van-tab title="注册" name="b">
						<div class="adddz login_input">
							<form @submit="doreg()">
								<div class="address_require">
									<label>邮箱<span>*</span></label>
									<input type="email" v-model="email">
								</div>
								<div class="address_require">
									<label>密码<span>*</span></label>
									<input type="password" v-model="password">
								</div>
								<div class="address_require">
									<label>确认密码<span>*</span></label>
									<input type="password" v-model="password2">
								</div>
								<div class="gw_accept_message">
									<van-checkbox v-model="checkedTP" shape="square" icon-size="18px" checked-color="#FE7A72">
										我已阅读并同意<router-link class="" :to="{path:'/agreement', query:{document: 'termsofusage'}}">《用户协议》</router-link>和
											<router-link class="" :to="{path:'/agreement', query:{document: 'securityandprivacy'}}">《隐私协议》</router-link></van-checkbox>
								</div>
								<van-button type="primary"  block native-type="submit" >创建帐户</van-button>
							</form>
						</div>
					</van-tab>
				</van-tabs>
				<!-- <van-divider :style="{ borderColor: '#ddd',margin: '2px 0'}"> OR SIGN IN WITH</van-divider>
				<p class="third_party_discount">
					Sign in with <span>Facebook</span> &amp; <span>Google</span> get <span>$10 off </span>on your first
					order!
				</p>
				<div class="login_kj f-clearfix">
					<div class="google_dl fl"><van-button color="#434343"  icon="https://www.xiangzh.com/images/google-register.png" block type="primary" v-on:click="go_login('google')">Google</van-button></div>
					<div class="facebook_dl fr"><van-button color="#506bae"  icon="https://www.xiangzh.com/images/facebooklogins.png" block type="primary" v-on:click="go_login('facebook')">Facebook</van-button></div>
				</div> -->
			</div>
		</div>
        <coupons-box v-if="user_coupons.length > 0" :user_coupons="user_coupons" :source="source"></coupons-box>
		<v-foot></v-foot>
	</div>
</template>
<style>
body{
	overflow-x: hidden;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
}
</style>
<script>
    import couponsBox from './coupons_box.vue'
	var _this;
	// @ is an alias to /src
	export default {
		components: {
            couponsBox
        },
        beforeRouteEnter(to,from,next){
			var tmp_reg_from = localStorage.getItem('reg_from');
			if(tmp_reg_from == "" || tmp_reg_from == undefined || from.fullPath !== '/Personal'){
				localStorage.setItem('reg_from',from.fullPath);
			}
            next()
        },
        created(){
			this.token_auto = this.$route.query.token;
			_this = this;
            var reg = this.$route.query.isreg;
            window.console.log(reg)
            if(reg !== undefined && reg === 'other'){
                this.reg = reg;
            }
			if(this.reg == ''){
                if(this.getUserInfo()){
					this.gourl_by_login();
					return;
                }
                this.refreshuinfo(false);
                this.show = true;
            }else {
                this.refreshuinfo(true);
                this.getUserCoupons()
            }

        },
		data() {
			return {
				activeName: 'a',
				checked:'',
				email:'',
				password:'',
				password2:'',
				checkedTP:false,
				token_auto:'',
                user_coupons: [],
                reg: '',
                source:'reg'
			}
		},
		methods: {
			dologin(){
				this.POST("api/user/login",{"accounts":this.email,"pwd":this.password},function(d){
						window.console.log(d);
					if(d.code != 0){
						_this.$toast(d.msg);
					}else{
						var result = _this.setUserInfo(d.data.user_info);
						if(result){
                            window.console.log(localStorage.getItem('reg_from'));
							_this.gourl_by_login();
						}else{
							_this.$toast("Error");
						}
					}
				});
			},
			doreg(){
				var agreement = this.checkedTP ? "on" : "";
				this.POST("api/user/register",{"accounts":this.email,"pwd":this.password,"pwd2":this.password2,"type":"emailnotauth","agreement":agreement},function(d){
						window.console.log(d);
					if(d.code != 0){
						_this.$toast(d.msg);
					}else{
						var result = _this.setUserInfo(d.data.data.user_info);
						if(result){
                            _this.user_coupons = d.data.data.user_coupon;
							//_this.$router.push('personal');
						}else{
							_this.$toast("Error");
						}
					}
				});
			},
			refreshuinfo(status){
				if(this.token_auto != ""){
					this.POST("api/user/refreshuinfo",{"token":this.token_auto},function(d){
						if(d.code != 0){
							// _this.$toast(d.msg);
						}else{
                            var result = _this.setUserInfo(d.data.data.user_info);
                            if(!status){
                                if(result){
									this.gourl_by_login();
                                }else{
                                    _this.$toast("Error");
                                }
                            }
						}
					});
				}
			},
			go_login(type){
				// var url_back = window.location.origin+"/"+window.location.hash;
				if(type == "google"){
					// window.location.href = "https://www.xiangzh.com/index/user/login_third_h5?type=google&url_back="+encodeURIComponent(url_back);
					window.location.href = "https://accounts.google.com/o/oauth2/auth?response_type=code&redirect_uri=https%3a%2f%2fshopping.alijietu.com%2findex%2fuser%2fcallback%2fname%2fgoogle.html&client_id=963852005643-lo0674p97t8mne8if4tlcegugkssnb80.apps.googleusercontent.com&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email&access_type=offline&approval_prompt=auto";
				}else if(type == "facebook"){
					// window.location.href = "https://www.xiangzh.com/index/user/login_third_h5?type=facebook&url_back="+encodeURIComponent(url_back);
					window.location.href = "https://m.facebook.com/dialog/oauth?client_id=959585611138839&redirect_uri=https%3a%2f%2fshopping.alijietu.com%2findex%2fuser%2fcallback%2fname%2ffacebook.html&scope=public_profile,email";
				}
			},
            getUserCoupons(){
                var url = 'api/coupon/couponsList';
                var data = {token:this.token_auto};

                this.POST(url,data,function (ret) {
                    if(ret.code === 0){
                        _this.user_coupons = ret.data.user_coupons;
                        _this.source = 'close'
                    }
                })
            }
			
		},
	}
</script>